import { createFileRoute } from '@tanstack/react-router';

import { LegalPageLayout } from '@/features/legal/components/legalPageLayout';
import { PrivacyPolicyContent } from '@/features/legal/components/privacyPolicyContent';

export const Route = createFileRoute('/privacy-policy')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LegalPageLayout title="Privacy Policy">
      <PrivacyPolicyContent />
    </LegalPageLayout>
  );
}
